// import { createReducer } from "@reduxjs/toolkit";
// import { GetItemTemp,GetWhsTotalQtybyitem,PostInvPosting} from "./inventoryPostingThunk";
// const initialState = {
//     GetDetailsItem: null,
//     GetWhsQty:null,
//     postResponse:null,
//     loading: false,
//     error: null,
//   };
//   export const ITPostingReducer = createReducer(initialState, (builder) => {
//     builder
     
//       .addCase(GetItemTemp.pending, (state) => {
//         state.loading = true;
//       })
    
//       .addCase(GetItemTemp.fulfilled, (state, action) => {
//         state.loading = false;
//         state.GetDetailsItem = action.payload;
//         state.error = null;
//       })
   
//       .addCase(GetItemTemp.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // wareHouse wise item qty 
//       .addCase(GetWhsTotalQtybyitem.pending, (state) => {
//         state.loading = true;
//       })
    
//       .addCase(GetWhsTotalQtybyitem.fulfilled, (state, action) => {
//         state.loading = false;
//         state.GetWhsQty = action.payload;
//         state.error = null;
//       })
   
//       .addCase(GetWhsTotalQtybyitem.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       .addCase(PostInvPosting.pending, (state) => {
//         state.loading = true;
//       })
    
//       .addCase(PostInvPosting.fulfilled, (state, action) => {
//         state.loading = false;
//         state.postResponse = action.payload;
//         state.error = null;
//       })
   
//       .addCase(PostInvPosting.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//     });

//     export default ITPostingReducer;




import { createReducer } from "@reduxjs/toolkit";
import { GetItemTemp, GetWhsTotalQtybyitem, PostInvPosting } from "./inventoryPostingThunk";

// Utility function to handle pending, fulfilled, and rejected actions
const handleAsyncActions = (builder, action, dataKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[dataKey] = true; 
      state[dataKey] = null; 
      state.error[errorKey] = null; 
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[dataKey] = false; 
      state[dataKey] = action.payload; 
      state.error[errorKey] = null; 
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[dataKey] = false; 
      state.error[errorKey] = action.payload; 
    });
};

const initialState = {
  // Data for each API
  GetDetailsItem: null,
  GetWhsQty: null,
  postResponse: null,

  // Dynamic loading and error states for each API
  loading: {
    GetDetailsItem: false,
    GetWhsQty: false,
    postResponse: false,
  },

  error: {
    GetDetailsItemError: null,
    GetWhsQtyError: null,
    postResponseError: null,
  },
};

export const ITPostingReducer = createReducer(initialState, (builder) => {
  // Handle async actions using the utility function
  handleAsyncActions(builder, GetItemTemp, "GetDetailsItem", "GetDetailsItemError");
  handleAsyncActions(builder, GetWhsTotalQtybyitem, "GetWhsQty", "GetWhsQtyError");
  handleAsyncActions(builder, PostInvPosting, "postResponse", "postResponseError");
});

export default ITPostingReducer;